/**
 * Main Feed Card Component File
 *
 * @author Creator-Solutions -> Owen Burns
 */
import { FC } from "react";
import { NavLink } from "react-router-dom";

import {
  CardTitleInfo,
  FeedCardContainer,
  PinnedContainer,
  PinnedContent,
  ProfileImage,
  TitleBar,
  CardAuthor,
  CardAuthorDetails,
  TopContainer,
  Dot,
  CardDate,
  TagContainer,
  Tags,
  BodyContent,
  Body,
  PostImage,
  Title,
  Impressions,
  ImpresionCaption,
} from "./styling/feedCard.styles";
import { ImpressionIcon, Pin, Profile } from "@/assets";

import parse from 'html-react-parser';


interface Props {
  FeedID: string;
  FeedTitle: string;
  FeedDate: string;
  FeedAuthor: string;
  FeedContent: string;
  FeedImage: string;
  FeedTags: string;
  Pinned: number;
  FeedLikes: number;
}

const FeedCard: FC<Props> = (props) => {
  return (
    <FeedCardContainer>
      <TopContainer>
        {props.Pinned === 1 ? (
          <PinnedContainer>
            <img src={Pin} alt="pin" />
            <PinnedContent>Pinned</PinnedContent>
          </PinnedContainer>
        ) : (
          <></>
        )}
      </TopContainer>
      <TitleBar>
        <ProfileImage src={Profile} alt="Profile" />
        <CardTitleInfo>
          <CardAuthorDetails>
            <CardAuthor>{props.FeedAuthor}</CardAuthor>
            <Dot />
            <CardDate>
              {new Date(props.FeedDate).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </CardDate>
          </CardAuthorDetails>
          <TagContainer>
            {props.FeedTags.split(";")
              .filter(Boolean)
              .map((item, index) => {
                return <Tags key={index}>{item}</Tags>;
              })}
          </TagContainer>
        </CardTitleInfo>
      </TitleBar>
      <BodyContent>
        <Title>{props.FeedTitle}</Title>
        <Body>
          {parse(props.FeedContent)}
        </Body>
        <PostImage src={props.FeedImage} alt="First Post" />
      </BodyContent>
      <Impressions>
        <img src={ImpressionIcon} alt=""/>
        <ImpresionCaption>Impressions</ImpresionCaption>
      </Impressions>
    </FeedCardContainer>
  );
};

export default FeedCard;
